<template>
  <div id="app" class="clearfloat">
    <div id="load" style="display: none;">
      <div class="overlay">
        <i>
          <img class="icon" src="./assets/img/load.png" alt="图片加载失败">
        </i>
        <span>加载中，请稍等片刻</span>
      </div>
    </div>
      <router-view ></router-view>
  </div>
</template>
<script>
  import store from './store'
  // import './assets/js/other/iconfont'
  export default {
    store,
    name: 'app',
    methods: {}
  }
</script>
<style lang="scss">

#app {
    width: 100%;
    height: 100vh;
}
</style>
